export default __webpack_public_path__ + "static/media/yeti.0d180fdf.png";